export default __webpack_public_path__ + "static/media/icongsoldier.3c1aa7ab.png";